import React, { useState } from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import { Assignment } from "@material-ui/icons";
import FilterArticle from "hooks/FilterArticle";
import { wsFindBy } from "services/WService";
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};
 
const columns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Cód. proveedor", accessor: "CardCode" },
  { Header: "Nombre proveedor", accessor: "CardName" },
  { Header: "Nombre categoría", accessor: "category" },
  { Header: "Nombre familia", accessor: "family" },
  { Header: "Cód. Producto", accessor: "code" },
  { Header: "Nombre producto", accessor: "article" },
  { Header: "IGV", accessor: "TaxRate" },
  { Header: "Precio Uni.", accessor: "unit_price" },
  { Header: "Precio Paq.", accessor: "package_price" },
  { Header: "", accessor: "actions", excelEnabled: false }
];

const useStyles = makeStyles(styles);

export default function PriceIgv() {
  const classes = useStyles();
  const [priceIgvs, setPriceIgvs] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listPriceIgvs(search) {
    setDataLoading(true);
    let response = await wsFindBy("logi/price-igv", search);
    setDataLoading(false);
    if (response.success) setPriceIgvs(response.data);
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado Precios con IGV {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterArticle getFilter={listPriceIgvs} priceList zone canal />

            <ReactTable
              excelName="Precios-IGV"
              defaultWidth={1900}
              indexRow={[0, 1, 2, 3, 4, 5, 6, 10]}
              widthRow={[80, 150, 300, 250, 250, 150, 300, 5]}
              columns={columns}
              data={priceIgvs.map((priceI, i) => {
                return {
                  num: i + 1,
                  CardCode: priceI.CardCode,
                  CardName: priceI.CardName,
                  category: priceI.logi_category_description,
                  family: priceI.logi_family_description,
                  code: priceI.ItemCode,
                  article: priceI.ItemName,
                  TaxRate: priceI.TaxRate + " %",
                  unit_price: priceI.unit_price_with_igv,
                  package_price: priceI.package_price_with_igv,
                  actions: ""
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
